<ng-container *ngIf="order$ | async as order; else loadingTmpl">
  <div class="receipt-header">
    <vnm-card-title header="checkout-receipt.title"></vnm-card-title>
    <button
      type="button"
      pButton
      icon="fa fa-fw fa-receipt"
      class="ml-auto"
      [label]="'checkout-receipt.button' | translate"
      [routerLink]="['user', 'orders', order.id]"
      (click)="onViewReceipt()"
    ></button>
  </div>
  <vnm-order-receipt [order]="order"></vnm-order-receipt>
</ng-container>
<ng-template #loadingTmpl>
  <vnm-empty-message
    icon="receipt"
    [loading]="true"
    loadingMessage="checkout-receipt.loading-message"
  ></vnm-empty-message>
</ng-template>
